'use strict';

require('./icon.css');
require('./material.min.css');
require('ace-css/css/ace.css');
require('font-awesome/css/font-awesome.css');
require('./loader.css');
require("./style.css");
require("./WordCloud/style.css");
require('./index.html');

var aboutPage = require('./public/ProcessBook.html.txt')
var $ = require('jquery');
import ports from './ports.js'

//var exportExample = require('./exportExample.js');
//exportExample.exportedFunction(fakeJSON);
var d3 = require("d3");

let hello = true;

var Elm = require('./Main.elm');
var mountNode = document.getElementById('main');

var app = Elm.Main.embed(mountNode, {
  aboutPage: aboutPage
});

ports.makePorts(app);



// WEBPACK FOOTER //
// ./src/index.js